import api from './api';

export interface Role {
  id: string;
  name: string;
  description?: string;
  isSystemRole: boolean;
}

class RoleService {
  async getRoles(): Promise<Role[]> {
    const response = await api.get<Role[]>('/roles');
    return response.data;
  }
}

export const roleService = new RoleService();
